import * as ngCore from '@angular/core'
import * as rxjs from 'rxjs'

import * as common from '../../../common'

import * as gql from './gql'
import * as models from './models'

@ngCore.Injectable()
export class ApiService {
  /** TODO: */
  public renderPage(
    request: models.page.Rendering.Request,
  ): rxjs.Observable<models.page.Rendering> {
    return gql.queries.mosaicPage.executor(request)
  }
}
